import { render, staticRenderFns } from "./Champions.vue?vue&type=template&id=0091e0fe&scoped=true"
import script from "./Champions.vue?vue&type=script&lang=js"
export * from "./Champions.vue?vue&type=script&lang=js"
import style0 from "./Champions.vue?vue&type=style&index=0&id=0091e0fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0091e0fe",
  null
  
)

export default component.exports